import HundredBricksAPI from '../HundredBricksAPI';
import AccountValueAPI from './accountValue/AccountValueAPI';
import BricksAPI from './bricks/BricksAPI';
import PreferencesAPI from './preferences';
import CapitalGainAPI from './capitalGain';
import OnSaleInvestmentsAPI from './onSale';
class InvestmentsAPI extends HundredBricksAPI {
    accountValueAPI;
    bricksAPI;
    capitalGainAPI;
    onSaleInvestmentsAPI;
    preferencesAPI;
    constructor(client) {
        super(client);
        this.accountValueAPI = new AccountValueAPI(client);
        this.bricksAPI = new BricksAPI(client);
        this.capitalGainAPI = new CapitalGainAPI(client);
        this.onSaleInvestmentsAPI = new OnSaleInvestmentsAPI(client);
        this.preferencesAPI = new PreferencesAPI(client);
    }
    async getAccountValueSummary() {
        return this.accountValueAPI.getSummary();
    }
    async getStandardCapitalGain() {
        return this.capitalGainAPI.getStandardCapitalGain();
    }
    async getLiquidityCapitalGain() {
        return this.capitalGainAPI.getLiquidityCapitalGain();
    }
    async getRealEstateCapitalGain() {
        return this.capitalGainAPI.getRealEstateCapitalGain();
    }
    async getPreferredPropertyValuation() {
        return this.preferencesAPI.getPropertyValuation();
    }
    async setPreferredPropertyValuation(payload) {
        return this.preferencesAPI.setPropertyValuation(payload);
    }
    async getStandardCapitalGainDetails() {
        return this.capitalGainAPI.getStandardCapitalGainDetails();
    }
    async getLiquidityCapitalGainDetails() {
        return this.capitalGainAPI.getLiquidityCapitalGainDetails();
    }
    async getRealEstateCapitalGainDetails() {
        return this.capitalGainAPI.getRealEstateCapitalGainDetails();
    }
    async getBricksInPreSale() {
        return this.bricksAPI.getBricksInPreSale();
    }
    async getPortfolioBricksByProperty(propertyId) {
        return this.bricksAPI.getPortfolioBricksByProperty(propertyId);
    }
    async getOnSaleInvestments(params) {
        return this.onSaleInvestmentsAPI.getOnSaleInvestments(params);
    }
    async getCapitalGain() {
        return this.capitalGainAPI.getCapitalGain();
    }
}
export default InvestmentsAPI;
